module.exports = __webpack_public_path__ + "static/media/newbeefpic09252021.892ad7dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/newbeefpic09252021.jpg
// module id = 320
// module chunks = 0